var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelmet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.494,
    height: "30mm",
    viewBox: "0 0 40.612 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.265
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4cc",
    d: "M39.512 6.829c-1.072 4.122-1.719 8.862-7.597 10.52l2.13 6.72c3.55-2.912 7.951-5.185 5.467-17.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4cc",
    d: "M4.551.131C3.323 5.067 3.073 9.62 7.087 12.495l-4.114 5.461c-3.27-3.45-5.11-7.84 1.578-17.825z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f978d",
    d: "M34.632 27.307s-.155-16.115-12.9-18.455C9.037 6.522 4.907 14.491 1.395 20.704z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#877d70",
    d: "M.558 20.477l34.931 6.691L34.931 30 0 23.308z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#877d70",
    d: "M29.005 12.6c.363.375.719.767 1.064 1.186-3.666 2.086-6.94 5.832-9.806 12.012l-1.655-.317c2.332-4.896 5.25-9.65 10.397-12.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#877d70",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    d: "M10.596 9.962c2.8 4.077 4.69 8.842 4.6 14.865l1.656.318c.045-5.566-1.25-10.946-4.789-15.82-.497.178-.985.397-1.467.637z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.265,
    d: "M4.585.103C3.695 4.71 2.954 9.277 7.12 12.466c6.374-6.198 20.68-5.537 25.16 4.772-.027-.164 5.42-.622 7.228-10.441 1.67 7.526.881 13.713-5.173 17.032l.307 3.118.874.213c-.017 1.368-.378 1.875-.567 2.811L.128 23.24.67 20.45l.85.213 1.513-2.717C.793 14.25-2.746 11.614 4.584.103z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.6306cf78c7171ae81183e395b99ade3a.svg";
export { ForwardRef as ReactComponent };